class Gallery {
  constructor() {
    const galleries = document.querySelectorAll('.js-gallery');

    galleries.forEach((gallery) => {
      // eslint-disable-next-line no-undef
      lightGallery(gallery, {
        selector: '.js-gallery-photo',
        thumbnail: false,
        share: false,
        download: false,
        zoom: false,
        subHtmlSelectorRelative: true,
      });
    });
  }
}

export default Gallery;
